import {Component} from '@angular/core';
import {SaveMessage} from '../../../_helpers/save-message';
import {OrdSped} from '../../../_models/OrdSped';
import {ModalController} from '@ionic/angular';
import {OrdinispedizioniService} from '../../../_services/ordinispedizioni.service';

@Component({
  selector: 'app-spedizione-update-send',
  templateUrl: './spedizione-update-send.component.html',
  styleUrls: ['./spedizione-update-send.component.scss'],
  standalone: false
})
export class SpedizioneUpdateSendComponent {
  today = new Date().toISOString();
  spedizione: OrdSped;
  loading = false;

  constructor(
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage,
    private spedizioneService: OrdinispedizioniService) { }


  saveSpedizione(ordSped: OrdSped) {
    this.loading = true;
    this.spedizioneService.updateOrdineSpedizione(ordSped)
      .then(() => this.modalCtrl.dismiss(true, 'save'))
      .finally(() => this.loading = false)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il salvataggio della spedizione."));
  }

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');
}
